import React from 'react';

export default () => (
  <div className="flex flex-direction-row">
    <div className="m-xxs is-8x8 is-round has-background-grey-light animation-pulse-1"></div>
    <div className="m-xxs is-8x8 is-round has-background-grey-light animation-pulse-2"></div>
    <div className="m-xxs is-8x8 is-round has-background-grey-light animation-pulse-3"></div>
  </div>
);
